import { Box, Center, Image } from '@mantine/core';
import { ImageIcon } from '@phosphor-icons/react/Image';
import type { FC } from 'react';

export const EventImage: FC<{ src?: string }> = ({ src }) => {
  return (
    <Box w="100%">
      {src ? (
        <Image
          alt="event-image"
          crossOrigin="anonymous"
          src={src}
          style={{
            aspectRatio: '4/5',
            objectFit: 'cover',
            borderRadius: 'var(--mantine-radius-sm)',
          }}
        />
      ) : (
        <Box
          bg="gigi-outlines"
          p="md"
          style={{ aspectRatio: '4/5', borderRadius: 'var(--mantine-radius-md)' }}
          w="100%"
        >
          <Center h="100%">
            <ImageIcon color="#C0C0C0" size={72} />
          </Center>
        </Box>
      )}
    </Box>
  );
};
